// src/pages/Home.js
import React, { useState, useRef, useEffect } from 'react';
import customers from './conf/Customers';
import CustomerStyles from './conf/CustomerStyles';
import { useMessage, showBootboxModal, ReactBootboxModal } from './conf/utils';
import { ScannerWrapper } from './conf/ScannerModal';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import * as global from './conf/global';
import { useNavigate } from 'react-router-dom';
import Shipment from './conf/Shipment';
import { deleteItem, getAllItems, updateItem} from './conf/bdd';
import { sendAllData, getSettings} from './conf/Webservice';
import generateDeviceId from './conf/device';
import { writeLogMsg } from './conf/log';

function Home() {
  // Exemples de variables d'état
  const [selectedCustomer, setSelectedCustomer] = useState(customers.shortlist.find(item => item.id.toString() === localStorage.getItem('customer')) || customers.shortlist.find(item => item.label === global.APP_DEFAULT_CUSTOMER) || customers.shortlist[0]);
  CustomerStyles(selectedCustomer);
  const [customersList, setCustomersList] = useState(customers.shortlist);
  const [keyValue, setKeyValue] = useState('');
  const [msgError, setMsgError] = useState(false);
  const [checked, setChecked] = useState(false);
  const [hideQuit, setHideQuit] = useState(false);
  const [nbPendingFiles, setNbPendingFiles] = useState(null);
  const [emailValue, setEmailValue] = useState(localStorage.getItem('userEmail') || '');
  const { openMessage, closeMessage, MessageComponent } = useMessage();
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'fr');
  const [deviceID, setDeviceID] = useState(localStorage.getItem('deviceID') || generateDeviceId());
  const navigation = useNavigate();
  var shipment;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);
  const [scanResult, setScanResult] = useState(false);
  const scanResultRef = useRef(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [askConfog, setAskConfig] = useState(localStorage.getItem('askConfig') || 'true');

  useEffect(() => {
    const getSettingsLog = async () => {
      await getSettings('Home', selectedCustomer.id).then(response => {
        global.APP_LOG_ENABLED = response.APP_LOG_ENABLED;
        writeLogMsg('Home: App log enabled:', global.APP_LOG_ENABLED);
      }).catch(error => {
        console.error('Home: Error fetching settings:', error);
        global.APP_LOG_ENABLED = false; // Fallback to false if there's an error
      });
    }

    getSettingsLog().then(() => {
      writeLogMsg('Home: Settings fetched successfully');
    }).then(() => {
      writeLogMsg('Home page');
      writeLogMsg('Home: Environment:', process.env.REACT_APP_P4C_WEB_ENV);
      writeLogMsg('Home: Url proxy:', process.env.REACT_APP_P4C_APP_URL);
      localStorage.setItem('deviceID', deviceID);
      writeLogMsg('Home: Device ID:', deviceID);
      localStorage.setItem('customer', selectedCustomer.id);
      writeLogMsg('Home: Selected customer ID:', selectedCustomer.id);
    }).then(() => {
      const sendData = async () =>  {
        writeLogMsg('Home: sendData: Sending data...');

        sendAllData('Home').then(() => {
          // Delete the item after sending
          deleteData();
        }).catch((error) => {
          console.error('Home: sendData: Error sending data:', error);
        });
      }

      const deleteData = async () => {
        try {
          writeLogMsg('Home: deleteData: Deleting old shipments...');
          // Delete old shipment
          const TWENTY_FOUR_HOURS = global.DB_PURGE * 60 * 60 * 1000;
          const now = Date.now(); // Heure actuelle
          var allItems = await getAllItems();
          writeLogMsg('All items:', allItems);
          for (var i = 0; i < allItems.length; i++) {
            const itemDate = allItems[i].ValidationDate;
            if (now - itemDate > TWENTY_FOUR_HOURS && allItems[i].Sent === true) {
              const itemId = allItems[i].DBIndex;
              writeLogMsg('Home: deleteData: Old sent item:', itemId);
              deleteItem(itemId).then(() => {
                writeLogMsg('Home: deleteData: Old sent item deleted:', itemId);
              });
            }
          }
          // Count not Sent shipment
          var notSentSize = 0;
          allItems = await getAllItems();
          //writeLogMsg('All items:', allItems);
          for (var j = 0; j < allItems.length; j++) {
            if (allItems[j].Sent === false) {
              notSentSize++;
            }
          }
          writeLogMsg('Home: deleteData: Not sent items count:', notSentSize);
          setNbPendingFiles(notSentSize);

        } catch (error) {
            console.error('Home: deleteData: Erreur lors du nettoyage des données:', error);
        }
      };

      // Send data on component mount
      sendData();
    }).then(() => {
      if (askConfog === 'true') {
        showBootboxModal(t('CONFIGURATION_MESSAGE'), t('CONFIGURATION_TITLE'), t('CONFIGURATION_BTNOK'), null, () => {
          localStorage.setItem('askConfig', 'false');
        });
      }
    });
  }, []);

  useEffect(() => {
    const handle = () => {
        // Tu veux empêcher de quitter ? Alors on ne fait rien
        console.log("Back ignoré sur Home");
    };

    window.addEventListener("app-back", handle);
    return () => window.removeEventListener("app-back", handle);
  }, []);

  
  useEffect(() => {
    const handleOnline = async () => {
      setIsOnline(true);
      writeLogMsg('Home: handleOnline: Vous êtes en ligne !');

      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'P4C_SYNC_ONLINE' });
        writeLogMsg('Home: handleOnline: Envoi du message de synchronisation au service worker');
      } else {
        writeLogMsg('Home: handleOnline: Service worker non disponible ou pas contrôleur actif');
      }

    };

    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  useEffect(() => {
    scanResultRef.current = scanResult;
  }, [scanResult]);

  const handleScanResult = (result) => {
    setScanResult(result);
  }

  const handleScanComplete = () => {
    // Accès à la valeur via ref
    if (scanResultRef.current) {
      setKeyValue(scanResultRef.current);
    }
    // Réinitialisation pour nouvelle ouverture
    setScanResult(null);
    setIsModalOpen(false);
  };
  
  const handleScanClose = () => {
    setScanResult(null); // Reset du résultat
    setIsModalOpen(false);
  };

  // Exemples de fonctions événementielles
  const changedCustomer = (newValue) => {
    const selectedCustomerData = customers.shortlist.find(item => item.id.toString() === newValue);
    localStorage.setItem('customer', selectedCustomerData.id);
    setSelectedCustomer(selectedCustomerData);
  };

  const changedKey = (newKey) => {
    setKeyValue(newKey);
    // Autres actions éventuelles
  };

  /**
  * Check if current collect is activated for customer (check status list)
  */
  var isCollectActivated = () => {
    var abActivated = false;
    if (selectedCustomer !== null && selectedCustomer !== "") {
      for (var i = 0; i < selectedCustomer.statusList.length && !abActivated; i++) {
        abActivated = (selectedCustomer.statusList[i].type === global.SHIP_TYPE_COL);
      }
    }
    return abActivated;
  };

  /**
  * Get barcode type for current customer
  */
  const getBarcodeType = (barcode) => {
    var astrBarcodeType = "";
    var aoShipRegEx = new RegExp(selectedCustomer.shipRegEx);
    var aoColRegEx = new RegExp(selectedCustomer.colRegEx);

    // Check if collect is activated for current customer
    if (isCollectActivated()) {
      // Check if Barcode is valide with RegExp of Delivery
      if (aoShipRegEx.test(barcode)) {
        // Check if Barcode is valide with RegExp of Collect
        if (aoColRegEx.test(barcode)) {
          // Barcode RegEx is valide with Delivery & Collect
          // Impossible to choose the type
          astrBarcodeType = global.SCREEN_CONFIRMATION;
        }
        else {
          astrBarcodeType = global.SHIP_TYPE_DEL;
        }
      }
      else {
        // Check if Barcode is valide with RegExp of Collect
        if (aoColRegEx.test(barcode)) {
          astrBarcodeType = global.SHIP_TYPE_COL;
        }
      }
    }
    else {
      // Check if Barcode is valide with RegExp of Delivery
      if (aoShipRegEx.test(barcode)) {
        astrBarcodeType = global.SHIP_TYPE_DEL;
      }
    }
    return astrBarcodeType;
  };

  const validate = async () => {
    var barcode = document.getElementById('inputKeyValue').value;
    writeLogMsg('Home: Validate: Barcode:', barcode);
    /** */
    // Logique de validation
    document.getElementById('msg_scan_error').style.visibility = 'hidden';
    var shipmentType = "";

    // Get the shipment type
    shipmentType = getBarcodeType(barcode);
    writeLogMsg('Home: Validate: Shipment type:', shipmentType);
    // Check if key is valid
    if (shipmentType !== "") {
      // Check if we need to ask WS for shipment informations
      if (selectedCustomer.wsConsult === customers.ws_consult.NoConsult) {
        // No WS consultation -> Start delivery with empty shipment
        shipment = new Shipment();
        shipment.ShipmentNumber = barcode;
        // Go to next screen
        goNextScreen(shipmentType);
      } else {
        var atOptions = {
          method: 'GET',
          timeout: global.HTTP_TIMEOUT,
          cache: 'no-cache',
          params: { 'fixCache': new Date().getTime() }
        };
        // Construct url
        var astrUrl = global.APP_URL + global.WS_SCAN;
        astrUrl = astrUrl.replace("%KEY%", selectedCustomer.code);
        astrUrl = astrUrl.replace("%CAB%", barcode);
        astrUrl = astrUrl.replace("%SHIPTYPE%", shipmentType);
        astrUrl = astrUrl.replace("%ID%", selectedCustomer.id);

        writeLogMsg('Home: Validate: URL:', astrUrl);

        // Check the barcode type is define (SHIP_TYPE_DEL / SHIP_TYPE_COL)
        writeLogMsg('wsConsult:', selectedCustomer.wsConsult);
        if (shipmentType !== global.SCREEN_CONFIRMATION) {
          // Ask web service for shipment infos
          try {
            const response = await fetch(astrUrl, atOptions);
            writeLogMsg('Home: Validate: Response:', response);
            if (!response.ok) {
              // Display Network error
              showBootboxModal(t('MSG_NETWORK_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
              return;
            }
            const data = await response.json();
            // WS success
            if (data.messageError === "" && data.found) {
              shipment = new Shipment();
              // Create new shipment with info returned by WS
              shipment.Customer = selectedCustomer;
              shipment.ShipmentType = shipmentType;
              shipment.ShipmentNumber = barcode;

              if (data.szName) shipment.ConsigneeName = data.szName;
              else shipment.ConsigneeName = "";

              if (data.phone) shipment.PhoneNumber = data.phone;
              else shipment.PhoneNumber = "";

              if (data.szAddress1) shipment.ConsigneeAddress1 = data.szAddress1;
              else shipment.ConsigneeAddress1 = "";

              if (data.szAddress2) shipment.ConsigneeAddress2 = data.szAddress2;
              else shipment.ConsigneeAddress2 = "";

              if (data.szAddress3) shipment.ConsigneeAddress3 = data.szAddress3;
              else shipment.ConsigneeAddress3 = "";

              if (data.postCode) shipment.ConsigneePostalCode = data.postCode;
              else shipment.ConsigneePostalCode = "";

              if (data.town) shipment.ConsigneeTown = data.town;
              else shipment.ConsigneeTown = "";
              
              shipment.AddressDefined = (shipment.ConsigneeName !== "" || shipment.ConsigneeAddress1 !== "" || shipment.ConsigneeAddress2 !== "" || shipment.ConsigneeAddress3 !== "" || shipment.ConsigneePostalCode !== "" || shipment.ConsigneeTown !== "");
            } else {
              shipment = new Shipment();
              shipment.Error = data.messageError;
              if (data.messageError === "UNKNOWN_CAB" && selectedCustomer.wsConsult === customers.ws_consult.ConsultOnly) {
                shipment.ShipmentNumber = barcode;
              }
            }
          } catch (error) {
            shipment = null;
            // Display Network error 
            console.error('Home: Validate: Error : ', error);
            //showBootboxModal(t('MSG_NETWORK_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
          }

          writeLogMsg('Home: Validate: Shipment: ', shipment);
          if (shipment != null) {
            if (shipment.ShipmentNumber !== undefined && shipment.ShipmentNumber !== "") {
              //shipment.CabScanned = keyValueScanned;
            } else {
              if (shipment.Error === "CAB_EVENTEXIST") {
                // Display Unknown shipment error
                showBootboxModal(t('MSG_CAB_EVENTEXIST'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                return;
              }
              else {
                // Display Unknown shipment error
                showBootboxModal(t('MSG_CAB_UNKNOWN'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                return;
              }
            }
          } else {
            if (selectedCustomer.wsConsult === customers.ws_consult.ConsultOnly || selectedCustomer.wsConsult === customers.ws_consult.ConsultAndExistAndNoNetwork) {
              // WS unreachable -> Start delivery with empty shipment
              shipment = new Shipment();
              shipment.ShipmentNumber = barcode;
            } else {
              // Display Network error
              showBootboxModal(t('MSG_NETWORK_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
              return;
            }
          }
          // Go to next screen
          goNextScreen(shipmentType);
        } 
        else {
          try {
            const response = await fetch(astrUrl, atOptions);
            writeLogMsg('Home: Validate: Response:', response);
            if (!response.ok) {
              // Display Network error
              showBootboxModal(t('MSG_NETWORK_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
              return;
            }
            const data = await response.json();
            // WS success
            if (data.messageError === "" && data.found) {
              // Create new shipment with info returned by WS
              shipment = new Shipment();
              shipment.Customer = selectedCustomer;
              shipment.ShipmentType = shipmentType;
              shipment.ShipmentNumber = barcode;
              if (data.szName) shipment.ConsigneeName = data.szName;
              if (data.phone) shipment.PhoneNumber = data.phone;
              if (data.szAddress1) shipment.ConsigneeAddress1 = data.szAddress1;
              if (data.szAddress2) shipment.ConsigneeAddress2 = data.szAddress2;
              if (data.szAddress3) shipment.ConsigneeAddress3 = data.szAddress3;
              if (data.postCode) shipment.ConsigneePostalCode = data.postCode;
              if (data.town) shipment.ConsigneeTown = data.town;
              shipment.AddressDefined = (shipment.ConsigneeName !== "" || shipment.ConsigneeAddress1 !== "" || shipment.ConsigneeAddress2 !== "" || shipment.ConsigneeAddress3 !== "" || shipment.ConsigneePostalCode !== "" || shipment.ConsigneeTown !== "");
            } else {
              shipment = new Shipment();
              shipment.Error = data.messageError;
              if (data.messageError === "UNKNOWN_CAB" && selectedCustomer.wsConsult === customers.ws_consult.ConsultOnly) {
                shipment.ShipmentNumber = barcode;
              }
            }
          } catch (error) {
            shipment = null;
            // Display Network error
            console.error('Home: Validate: Error:', error);
            //showBootboxModal(t('MSG_NETWORK_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
          }

          if (shipment != null) {
            if (shipment.ShipmentNumber !== undefined && shipment.ShipmentNumber !== "") {
              // Go to next screen
              goNextScreen(shipmentType);
            } else {
              if (shipment.astrError === "CAB_EVENTEXIST") {
                // Display Unknown shipment error
                showBootboxModal(t('MSG_CAB_EVENTEXIST'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                return;
              }
              else {
                // Display Unknown shipment error
                showBootboxModal(t('MSG_CAB_UNKNOWN'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                return;
              }
            }
          } else {
            // Display Network error
            showBootboxModal(t('MSG_NETWORK_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
            return;
          }
        }
      }
    } else {
      showBootboxModal(t('MSG_SCAN_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
      //document.getElementById('msg_scan_error').style.visibility = 'visible';
      return;
    }
  };

  /***/
  const goNextScreen = (shipmentType) => {
    // Check delivery or collect ?
    if (shipmentType === global.SCREEN_CONFIRMATION) {
      shipment = new Shipment();
      shipment.Customer = selectedCustomer;
      shipment.ShipmentType = shipmentType;
      shipment.ShipmentNumber = keyValue;
      // Sérialisation
      const serializedShipment = {
        ...shipment
      };
      navigation('/Confirmation', { state: { shipment: serializedShipment, chooseMessageShipment: true } }); //screen for choose between delivery & collect
    }
    else {
      // Check if shipment has been well initialized
      if (shipment !== null) {
        if (shipment.ShipmentNumber !== undefined && shipment.ShipmentNumber !== "") {
          shipment.Customer = selectedCustomer;
          shipment.ShipmentType = shipmentType;
          // Sérialisation
          const serializedShipment = {
            ...shipment
          };
          navigation('/Delivery', { state: { shipment: serializedShipment } });
        }
      }
    }
  }
  /***/

  const scan = () => {
    // Logique de scan
  };

  const openScan = () => {
    requestAnimationFrame(() => {
      try {
        const status = navigator.permissions.query({ name: 'camera' });
        writeLogMsg('Home: Validate: openScan: camera permission state:', status.state);
      } catch (err) {
        console.error('Permission query failed:', err);
      }
      if ("mediaDevices" in navigator && "getUserMedia" in navigator.mediaDevices)
      {
        navigator.mediaDevices.getUserMedia({ video: true })
        .then((stream) => {
          stream.getTracks().forEach(track => track.stop());
          setIsModalOpen(true);
        })
        .catch((err) => {
          console.error('Home: Validate: openScan: getUserMedia failed:', err.name, err.message);
          showBootboxModal(t('PERMISSION_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
        });
      } else {
        showBootboxModal(t('NAVIGATOR_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
      }
    });
  };

  const openPhotoModal = () => {
    setIsPhotoModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  const logout = () => {
    // Logique de déconnexion
  };

  const toggle = () => {
    setChecked(!checked);
  };

  const changedLang = (newLang) => {
    // Logique de changement de langue
    i18n.changeLanguage(newLang);
    setSelectedLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  const validEmail = () => {
    const savedEmail = localStorage.getItem('userEmail');

    const regex = new RegExp(global.EMAIL_REGEX);
    // Logique de validation de l'email
    if (emailValue === "" || regex.test(emailValue)) {
      if (emailValue !== savedEmail) {
        localStorage.setItem('userEmail', emailValue);
      }
    }
    else {
      showBootboxModal(t('ERROR_MAIL_MSG'), t('ERROR_MAIL_TITLE'), t('ERROR_MAIL_BTNOK'), null, () => {
        document.getElementById('inputEmail').value = savedEmail;
        // Use setTimeout to ensure the input is focused after the modal is fully rendered
        setTimeout(() => {
          const inputEmail = document.getElementById('inputEmail');
          if (inputEmail) {
            // Changer temporairement le type en 'text'
            const originalType = inputEmail.type;
            inputEmail.type = 'text';
            inputEmail.focus();
            // Placer le curseur à la fin du texte
            inputEmail.setSelectionRange(inputEmail.value.length, inputEmail.value.length);
            // Remettre le type original
            inputEmail.type = originalType;
          }
        }, 100); // Adjust the delay as necessary
        setEmailValue(localStorage.getItem('userEmail') || '');
      }, null);
    }
  };

  const handleHistoric = () => {
    navigation('/Historic');
  };

  return (
    <div id="mainDiv" className='page-container' style={{ position: 'static' }} >
      {/* Conteneur principal */}
      <div className='content-wrap'>
        {/* Barre de navigation */}
        <nav className="navbar navbar-expand-lg navbar-fixed-top navbar-default col-sm-12" role="navigation" style={{ display: 'flow-root' }}>
          <div className="menu-icon menu-icon-arrow float-left" onClick={toggle}>
            <span />
          </div>
          {/* 
          <div className="float-right">
            {!hideQuit && (
              <a className="navbar-brand" onClick={logout}>
                <span className="glyphicon glyphicon-off glyphiconmenu" />
              </a>
            )}
          </div>*/}
        </nav>

        {/* Logo + Sélection du client */}
        <div className="col-sm-10 col-lg-8 mx-auto">
          <div className="form-group">
            {selectedCustomer && selectedCustomer.name && (
              <img
                src={`assets/images/xhdpi/logo-${selectedCustomer.name}.png`}
                srcSet={`assets/images/mdpi/logo-${selectedCustomer.name}.png 320w,
                         assets/images/hdpi/logo-${selectedCustomer.name}.png 480w,
                         assets/images/xhdpi/logo-${selectedCustomer.name}.png 640w,
                         assets/images/xxhdpi/logo-${selectedCustomer.name}.png 960w`}
                alt={`Logo ${selectedCustomer.name}`}
                className="img-responsive logo_center_img"
              />
            )}
          </div>
          <div className="form-group">
            <select
              id="selectedCustomerid"
              className="form-control input-xs"
              value={selectedCustomer && selectedCustomer.id ? selectedCustomer.id : ''}
              onChange={(e) => changedCustomer(e.target.value)}
            >
              {customersList.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.label}
                </option>
              ))}
            </select>
          </div>

          {/* Champ Key */}
          <div className="row scaninfo">
            <label htmlFor="inputKeyValue" className='label-text col-12'>{t('ID_KEY_' + selectedCustomer.code)}</label>

            <div className="col-9 pr-0">
              <input
                type="text"
                className="form-control"
                id="inputKeyValue"
                value={keyValue}
                onChange={(e) => changedKey(e.target.value)}
              />
            </div>
            <div className="col-3 pl-0">
            <button
                type="button"
                className="form-control btn btn-default btn-secondary btn-block"
                onClick={openScan}
              >
                
                <img
                  src="assets/images/xhdpi/BtnScan.png"
                  srcSet={`assets/images/mdpi/BtnScan.png 320w,
                           assets/images/hdpi/BtnScan.png 480w,
                           assets/images/xhdpi/BtnScan.png 640w,
                           assets/images/xxhdpi/BtnScan.png 960w`}
                  alt="Scan"
                  className="w-100"
                  style={{height: '100%'}}
                />
              </button>
              <ReactBootboxModal
                isOpen={isModalOpen}
                onClose={handleScanClose}
                onConfirm={handleScanComplete}
                title={t('HOME_TITLE_BARCODE')}
                cancelLabel={t('HOME_CANCEL_BARCODE')}
                showCancel={true}
              >
                <ScannerWrapper
                  onScan={(result) => {
                    handleScanResult(result); // Mise à jour du state parent
                    writeLogMsg("Résultat dans Parent:", result);
                  }}
                />
              </ReactBootboxModal>
            </div>
          </div>

          {/* Message d'erreur éventuel */}
          {/* {msgError && (*/}
          <div id="msg_scan_error" className="alert alert-danger" style={{ visibility: 'hidden' }}>
            <span className="glyphicon glyphicon-exclamation-sign" />
            <span style={{ padding: '10px' }}>{`${msgError}`}</span>
          </div>
          {/* )} */}


          {/* Bouton de validation */}
          <div className="text-center">
            <button
              id="btnValid"
              onClick={validate}
              className="btn btn-default btn-big bold"
            >
              {t('BTN_VALID')}
            </button>
            <MessageComponent>
              <p>{`${msgError}`}</p>
            </MessageComponent>
          </div>
        </div>

        {/* Backdrop pour menu latéral (similaire à pageslide-back) */}
        {checked && (
          <div className="pageslide-back" onClick={toggle} />
        )}

        {/* Menu latéral (à animer si souhaité) */}
        {checked && (
          <div
            className="pageslide"
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '70%',
              height: '100%',
              background: '#fff',
              maxWidth: '300px',
              zIndex: 1000,
              transition: 'transform 0.3s ease-in-out',
              transform: 'translateX(0)',
              // Autres styles ou animations
            }}
          >
            {/* Sélection de la langue */}
            <div >
              <div className="navbar navbar-default" style={{ display: 'flow-root' }}>
                <span className="float-right menu-icon-arrow glyphicon glyphicon-menu-left" onClick={toggle}></span>
              </div>
              <div className="menu-padding">

                <label htmlFor="selectLanguage">{t('MSG_LANG')}</label>
                <select
                  id="selectLanguage"
                  value={selectedLanguage}
                  onChange={(e) => changedLang(e.target.value)}
                  className="form-control input-xs"
                >
                  <option value="fr">{t('LANG_FR')}</option>
                  <option value="en">{t('LANG_EN')}</option>
                  <option value="de">{t('LANG_DE')}</option>
                  <option value="es">{t('LANG_ES')}</option>
                  <option value="it">{t('LANG_IT')}</option>
                  <option value="pl">{t('LANG_PL')}</option>
                </select>
                <hr />

                {/* Email */}
                <label htmlFor="inputEmail">{t('MAIL')}</label>
                <input
                  type="email"
                  className="form-control"
                  id="inputEmail"
                  value={emailValue}
                  onChange={(e) => setEmailValue(e.target.value)}
                  onBlur={validEmail}
                />
                <hr />

                {/* Fichiers en attente */}
                <label>{t('NB_FILE')}</label> <span className="badge">{nbPendingFiles}</span>
                {/* Bouton d'historique */}
                <button
                  id="btnHistoric"
                  onClick={handleHistoric}
                  className="btn btn-default btn-secondary btn-block btn-historic"
                >
                  {t('HISTORIC')}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Pied de page */}
      <footer className="footer">
        <div className="container col-12">
          <a
            href="https://pod4carriers.com/politique-de-confidentialit%c3%a9/"
            target="_blank"
            rel="noreferrer"
          >
            {t('PRIVACY')}
          </a>
          <p className="text-muted">© Panoptès - v{global.APP_VERSION}</p>
        </div>
      </footer>
    </div>
  );
}

export default Home;
